<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item style="color: #a8abb2">学习记录</el-breadcrumb-item>
      <el-breadcrumb-item>登录授权管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="study_form">
      <el-form
        :inline="true"
        label-width="80px"
        :model="searchForm"
        label-position="top"
        size="small"
      >
        <el-row>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="姓名/账号">
              <el-input v-model="searchForm.user"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="用户ID/插件ID">
              <el-input v-model="searchForm.user_id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="发起时间">
              <dataPicker
                style="width: 321px"
                :datevalue.sync="searchForm.time_add"
              ></dataPicker>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label=" ">
              <el-button
                icon="el-icon-refresh"
                size="medium"
                @click="clearForm"
              >
                清除条件
              </el-button>
              <el-button
                type="goon"
                icon="el-icon-search"
                size="medium"
                @click="submitForm"
              >
                搜索
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="cotent_table">
      <el-table
        class="boder_table"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="tableData.loading"
      >
        <el-table-column
          prop="user_id"
          label="用户ID"
          width="235"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="username"
          label="账号"
          align="center"
          width="235"
        >
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="姓名"
          align="center"
          width="235"
        >
        </el-table-column>
        <el-table-column
          prop="plug_id"
          label="插件ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="add_time"
          label="发起时间"
          align="center"
          width="300"
        ></el-table-column>
        <el-table-column prop="" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="status === 1"
              @click="agreeLogin(scope)"
              >同意授权</el-button
            >
            <el-button
              type="text"
              v-if="status === 1"
              @click="refuseLogin(scope)"
              >拒绝授权</el-button
            >
            <span
              v-if="status === 2 && scope.row.status == 2"
              style="color: #ff4949"
              >拒绝授权</span
            >
            <span
              v-if="status === 2 && scope.row.status == 3"
              style="color: #13ce66"
              >同意授权</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table_foot">
        <!-- 按钮组 -->
        <div>
          <el-button
            size="small"
            :type="status === 1 ? 'goon' : ''"
            icon="el-icon-time"
            @click="onUntreated"
            >未处理</el-button
          >
          <el-button
            size="small"
            icon="el-icon-circle-check"
            :type="status === 2 ? 'goon' : ''"
            @click="onProcessed"
            >已处理</el-button
          >
        </div>
        <!-- 分页器 -->
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableOpt.page"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      searchForm: {
        user: "",
        user_id: "",
        time_add: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(1, "d").format("YYYY-MM-DD"),
        ],
      },
      status: 1,
      tableData: {
        data: [],
        total: 0,
        page: 1,
        page_size: 10,
        loading: false,
      },
      tableOpt: {
        page: 1,
        page_size: 10,
      },
    };
  },
  methods: {
    async getList() {
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("authorization/list", {
        ...searchForm,
        ...tableOpt,
        status: this.status,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { list, page, page_size, total } = res;
      this.tableData.loading = false;
      this.tableData.data = list;
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
    },
    onUntreated() {
      if (this.status === 1) {
        return;
      }
      this.status = 1;
      this.getList();
    },
    onProcessed() {
      if (this.status === 2) {
        return;
      }
      this.status = 2;
      this.getList();
    },
    clearForm() {
      this.searchForm = {
        user: "",
        user_id: "",
        time_add: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(1, "d").format("YYYY-MM-DD"),
        ],
      };
      this.status = 1;
      this.tableOpt = {
        page: 1,
        page_size: 10,
      };
    },
    submitForm() {
      this.getList();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.tableOpt.page = val;
      this.getList();
    },
    refuseLogin(data) {
      const { row } = data;
      this.$confirm("确认拒绝这条授权请求？", "提示")
        .then(async (_) => {
          const { id } = row;
          const [err, res] = await this.$http.post("authorization/audit", {
            id: id,
            operation: "off",
          });

          if (err) {
            this.$message({
              showClose: true,
              message: err,
              type: "error",
            });
            return;
          }

          this.$message({
            showClose: true,
            message: "已拒绝",
            type: "success",
          });

          this.getList();
        })
        .catch((_) => {});
    },
    agreeLogin(data) {
      const { row } = data;
      this.$confirm("确认授权该请求？", "提示")
        .then(async (_) => {
          const { id } = row;
          const [err, res] = await this.$http.post("authorization/audit", {
            id: id,
            operation: "on",
          });

          if (err) {
            this.$message({
              showClose: true,
              message: err,
              type: "error",
            });
            return;
          }
          this.$message({
            showClose: true,
            message: "授权成功",
            type: "success",
          });
          this.getList();
        })
        .catch((_) => {});
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.el-button--goon,
.el-button--goon:focus,
.el-button--goon.is-active,
.el-button--goon:active {
  background: #2ab18b;
  border-color: #2ab18b;
  color: #fff;
}
.el-button--goon:hover {
  background: #8cd8da;
  border-color: #8cd8da;
  color: #fff;
}
.el-button--goon:focus {
  background: #0a8965;
  border-color: #0a8965;
  color: #fff;
}
.study_form {
  background: #fff;
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  /deep/.el-input--small .el-input__inner {
    width: 300px;
  }
  /deep/.el-form-item__label {
    min-height: 42px;
    min-width: 50px;
  }
  /deep/.el-range-editor.el-input__inner {
    padding: 2px 10px;
  }
}
.cotent_table {
  background: #fff;
  margin-top: 16px;
  padding: 20px;
  .table_foot {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    /deep/.el-pager li.active {
      color: #2ab18b;
    }
    /deep/ .el-pager li:hover {
      color: #2ab18b;
    }
  }
}
</style>